<div class="header">
    <div class="header-label">
        <div class="header-label-title">
            {{title | translate: i18nParams}}
        </div>
    </div>
</div>
<div class="main">
    <fui-fields>
        <ng-content></ng-content>
    </fui-fields>
</div>
